import React, { useState } from "react";
import withDashboardLayout from "../../hoc/withDashboardLayout";
import { Tabs } from "antd";
import GenerateInvoice from "../../components/admin/transactions/GenerateInvoice";
import AutoRefund from "../../components/admin/refunds/AutoRefund";
// import Request from "../../components/admin/refunds/Request";

const Refunds = () => {
  const [refundsActiveTab, setRefundsActiveTab] = useState("autoRefund");
  const [generateInvoice, setGenerateInvoice] = useState(false);

  const tabItems = [
    {
      key: "autoRefund",
      label: "Auto Refund",
      children: <AutoRefund refundsActiveTab={refundsActiveTab} />,
    },
    // {
    //   key: "request",
    //   label: "Request",
    //   children: <Request refundsActiveTab={refundsActiveTab} />,
    // },
  ];

  const onTabChange = (key) => {
    setRefundsActiveTab(key);
  };

  return (
    <div className="w-full h-full">
      <div className="w-[95%] mx-auto">
        <div className="w-full py-4">
          <div className="flex items-center justify-between">
            <h2 className="font-semibold title text-lg text-[#000000]">
              Refunds
            </h2>
          </div>
        </div>

        {/* Refunds Tabs */}
        <div className="w-full main-scroll min-h-[calc(100vh-170px)] h-[352px] overflow-scroll flex flex-col gap-y-4 box-shadow rounded-2xl pt-5 bg-white">
          <div className="w-full space-tab">
            <Tabs
              defaultActiveKey="autoRefund"
              activeKey={refundsActiveTab}
              items={tabItems}
              onChange={onTabChange}
            />
          </div>
        </div>
      </div>

      <GenerateInvoice
        generateInvoice={generateInvoice}
        setGenerateInvoice={setGenerateInvoice}
      />
    </div>
  );
};

export default withDashboardLayout(Refunds);
